module.exports = __webpack_public_path__ + "media/images/flags/mv-0329f53cf8f786716fe4c85fecf33bf2.svg";